import React, { FunctionComponent } from 'react';

import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
    ICON_PATHS,
    TRANSLATION_NAMESPACE,
    NOTIFICATION_VARIANT,
} from 'directory/listings/notification-modals/constants';
import { NotificationBannerProps } from 'directory/listings/notification-modals/types';

import 'directory/listings/notification-modals/components/NotificationBanner/NotificationBanner.scss';

export const NotificationBanner: FunctionComponent<NotificationBannerProps> = ({
    icon,
    title,
    message,
    variant = NOTIFICATION_VARIANT.INFO,
    customStyles,
}) => {
    const { t } = useTranslation(TRANSLATION_NAMESPACE);

    const defaultStyles: React.CSSProperties = {
        backgroundColor: '#E4F9F9',
        border: '0.0625rem solid #9DE9EE',
    };

    const defaultIcon = (
        <span role="img" aria-label="bulb" className="notification-banner__icon-container">
            <img src={ICON_PATHS.BULB} alt="bulb icon" className="notification-banner__icon-image" />
        </span>
    );

    const defaultTitle = t('INCOMPLETE_LISTINGS_TITLE');
    const defaultMessage = <p className="mb-0 small text-muted">{t('INCOMPLETE_LISTINGS_DESC')}</p>;

    return (
        <Alert
            variant={variant}
            className="notification-banner d-flex align-items-start"
            style={customStyles || defaultStyles}
        >
            <span className="notification-banner__icon">{icon || defaultIcon}</span>
            <div className="notification-banner__content">
                <strong className="notification-banner__title">{title || defaultTitle}</strong>
                {typeof message === 'string' ? (
                    <p className="notification-banner__message small text-muted">{message}</p>
                ) : (
                    <div className="notification-banner__message">{message || defaultMessage}</div>
                )}
            </div>
        </Alert>
    );
};
